import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './LocusRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class LocusRobotics_serialValidation_requestService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { SerialValidationRequest?: { EventType?: string, JobId?: string, OrderId?: string, OrderLineId?: string, ItemNo?: string, JobTaskId?: string, Quantity?: number, Serial?: string }, transactionId?: string }): Promise<{ SerialValidationResult?: { SerialNumber?: string, IsError?: boolean, Message?: string } }> 
  {
    let url = `${environment.backendUrl}api/LocusRobotics/functions/serialValidation_request`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

